import { Button } from '@cibli/shared';
import { Banknote, CreditCard, LockKeyhole, ThumbsUp, Wifi } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import Hint from '@/features/common/components/Hint';
import MainLayout from '@/features/common/components/MainLayout';

interface Props {
  onValidate: () => void;
  onCancel: () => void;
}

export default function PaymentScreen({ onValidate, onCancel }: Props) {
  const { t } = useTranslation();

  const handlePay = () => {
    // Payment intent will be created in ProceedToPaymentScreen
    onValidate();
  };

  return (
    <MainLayout className="gap-12 sm:gap-20" onClose={onCancel}>
      <h1 className="text-2xl md:text-3xl lg:text-4xl text-center text-balance">
        {t('FormScreen.Payment.title')} <span className="text-primary">2 €</span>
      </h1>
      <p className="text-lg md:text-xl lg:text-2xl max-w-xl text-center text-balance text-muted-foreground">
        {t('FormScreen.Payment.description')}
      </p>
      <div className="flex flex-col gap-4 sm:gap-6 font-semibold">
        <Hint hint={t('FormScreen.Payment.pros.contactLess')} icon={<Wifi />} />
        <Hint hint={t('FormScreen.Payment.pros.instantAndSecure')} icon={<LockKeyhole />} />
        <Hint hint={t('FormScreen.Payment.pros.letsgo')} icon={<ThumbsUp />} />
        <Hint hint={t('FormScreen.Payment.pros.billedAtEnd')} icon={<Banknote />} />
      </div>
      <Button size="lg" className="w-full sm:w-auto" onClick={handlePay}>
        <CreditCard className="size-4" />
        Payer
      </Button>
    </MainLayout>
  );
}
